<template>
  <el-table
    v-loading="listLoading"
    :key="0"
    :data="alist"
    border
    fit
    highlight-current-row
    style="width: 100%;min-height:1000px;"
  >
    <el-table-column label="会员ID" align="center" width="100px">
      <template slot-scope="scope">
        <span>{{ scope.row.memberId }}</span>
      </template>
    </el-table-column>
    <el-table-column label="会员名" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.memberName }}</span>
      </template>
    </el-table-column>
    <el-table-column label="账户类型" align="center" width="120px">
      <template slot-scope="scope">
        <span>{{ scope.row.memberType | accountTypeFilter }}</span>
      </template>
    </el-table-column>
    <el-table-column label="卡号" align="center" width="100px">
      <template slot-scope="scope">
        <span>{{ scope.row.memberCardNo }}</span>
      </template>
    </el-table-column>
    <el-table-column label="车牌号" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.memberCarNo | blankFilter }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作站点" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.optStationName }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作员工" align="center" width="120px">
      <template slot-scope="scope">
        <span>{{ scope.row.optEmpName }}</span>
      </template>
    </el-table-column>
    <el-table-column label="销户时间" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.createdTime }}</span>
      </template>
    </el-table-column>
    <el-table-column label="备注" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.memo | blankFilter }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'Closes',
  filters: {
    blankFilter (val) {
      if (!val && val !== 0 || val === 'null' || val === 'undefined') {
        return ''
      } else {
        return val
      }
    },
    accountTypeFilter (type) {
      switch (type) {
        case 1:
          return '散户'
        case 2:
          return '车队子账户'
        case 3:
          return '车队总账户'
        default:
          return ''
      }
    }
  },
  props: {
    alist: {
      type: Array,
      required: true,
      twoWay: true
    },
    listLoading: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  }
}
</script>

